export default __webpack_public_path__ + "static/page2viewport1-4d403e665c616dc2235b5ae3c7a9038c.png";